export enum StatusEnum {
  VALID = "VALID",
  NOT_STARTED = "NOT_STARTED",
  STARTED = "STARTED",
  PROGRESS = "PROGRESS",
  CANCELED = "CANCELED",
  INVALID = "INVALID",
  FAILED = "FAILED",
}
